import React, { useRef, useState } from "react";
import { DocWriteBackStatus } from "../../../../../shared/enums/evBvWriteBackStatus";
import DocWithUploadIcon from "../../../../../shared/svg/doc-with-upload-icon";
import ToolTipUsingPortal from "../../../toolTipUsingPortal/toolTipUsingPortal";

interface DocWithUploadIconCellProps {
  value: {
    status: string;
    filePaths?: any;
    shouldHideUploadIcon: boolean;
    rowData?: any;
  };
  handleIconClickOnDocumentScreenshot?: (rowData: any) => void;
  [key: string]: any;
}

export const DocWithUploadIconCell: React.FC<DocWithUploadIconCellProps> = ({
  value,
  handleIconClickOnDocumentScreenshot,
}) => {
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const commentModalRef = useRef<HTMLDivElement>(null);

  const getColorBasedOnStatusDocWithUploadIcon = () => {
    switch (value.status) {
      case DocWriteBackStatus.SUCCESS:
        return "#00775E";
      case DocWriteBackStatus.ERROR:
        return "#CC0300";
      case DocWriteBackStatus.IN_PROGRESS:
      case DocWriteBackStatus.QUEUED:
        return "#0056D6";
      default:
        return "#999999";
    }
  };

  const getStatusTextDocWithUploadIcon = () => {
    switch (value.status) {
      case DocWriteBackStatus.SUCCESS:
        return "Doc(s) is added";
      case DocWriteBackStatus.ERROR:
        return "Failed in uploading doc(s)";
      case DocWriteBackStatus.IN_PROGRESS:
      case DocWriteBackStatus.QUEUED:
        return "Doc(s) is being added";
      default:
        return "Doc(s) upload not initiated";
    }
  };

  return value?.shouldHideUploadIcon ? (
    <></>
  ) : (
    <>
      <div
        className="table-cell-rpa-status ml-auto flex h-full w-full items-center justify-center"
        onMouseEnter={() => setIsCommentModalOpen(true)}
        onMouseLeave={() => setIsCommentModalOpen(false)}
        ref={commentModalRef}
        onClick={(e) => {
          e.stopPropagation();
          handleIconClickOnDocumentScreenshot?.(value?.rowData);
        }}
      >
        <DocWithUploadIcon
          color={getColorBasedOnStatusDocWithUploadIcon()}
          height={"24px"}
          width={"24px"}
        />

        <ToolTipUsingPortal
          children={getStatusTextDocWithUploadIcon()}
          placement={"left"}
          showTooltip={isCommentModalOpen}
          parentRef={commentModalRef}
        />
      </div>
    </>
  );
};

export default DocWithUploadIconCell;
